import { Component, Inject, OnInit, PLATFORM_ID, TransferState, makeStateKey } from '@angular/core';

import { ActivatedRoute, ParamMap } from '@angular/router';
import { CertificateService } from '../../service/CertificateService/CertificateService.service';
import { envStateKeyModel } from '../../app.config.server';
import { CommonModule } from '@angular/common';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

const ENV_KEY = makeStateKey<envStateKeyModel>('env');

@Component({
    selector: 'app-preview-certificate',
    imports: [
        CommonModule
    ],
    templateUrl: './preview-certificate.component.html',
    styleUrl: './preview-certificate.component.css'
})

export class PreviewCertificateComponent implements OnInit {
  certificate: any | null = null;
  uid: string | null = null;
  description: string | null = null;
  backgroundImageUrl: string = 'url(assets/certificate.png)'; // Default image
  isPdf: boolean = false;

  constructor(
    private transferstate: TransferState,
    private certificateService: CertificateService,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.route.queryParamMap,
      this.route.paramMap
    ]).pipe(
      map(([queryParamMap, paramMap]: [ParamMap, ParamMap]) => {
        return queryParamMap.keys.length > 0 ? queryParamMap : paramMap;
      })
    ).subscribe((params: ParamMap) => {
      const uid = params.get('uid')?.replace(/\/$/, '');

      if (uid) {
        this.isPdf = this.route.snapshot.queryParamMap.get('pdf') === 'true';
        const env = this.transferstate.get<envStateKeyModel>(ENV_KEY, {SHARE_URL:"", AMPLIFYME_URL: "", PATHWAYS_URL: "", HUBSPOT_TRACKING_CODE: ""});
        this.certificateService.getCertificate(env.SHARE_URL, uid).subscribe((certificate: any) => {
          this.certificate = certificate;
          switch (this.certificate.event.subtype) {
            case 'Finance Accelerator': {
              this.description = 'Finance Accelerator Simulation Experience in Partnership with Morgan Stanley';
              this.backgroundImageUrl = 'url(assets/certificate-ms.png)';
              break;
            }
            case 'Mergers And Acquisition': {
              this.description = "Banking Accelerator Simulation Experience";
              this.backgroundImageUrl = 'url(assets/certificate.png)';
              break;
            }
            case 'Sales & Trading': {
              this.description = 'Level 4 Diploma Investment Bank Sales & Trading';
              break;
            }
            case 'Global Macro': {
              this.description = 'Level 4 Diploma Asset Management';
              break;
            }
            case 'Quant Accelerator': {
              this.description = 'Quant Accelerator Simulation Experience';
              this.backgroundImageUrl = 'url(assets/certificate.png)';
              break;
            }
            default: {
              this.description = 'Simulation Experience';
              break;
            }
          }
        });
      }
    });
  }
}

